<template>
  <div class="container">
    <div class="image-wrapper">
      <!--<i class="el-icon-success icon" v-if="!!image.class_id"></i>-->
      <div class="btn-wrapper">
        <el-popover
          ref="popover1"
          placement="top-start"
          trigger="hover">
          <img :src="image.dish_img_url" alt="">
          <el-button type="text" class="btn" icon="el-icon-search" slot="reference"></el-button>
        </el-popover>
        <!--<el-button type="text" v-if="deleteShow" class="btn danger-text" icon="el-icon-delete"-->
                   <!--@click="handleDelete"></el-button>-->
      </div>
      <div class="mask-wrapper" @mouseenter="imageOnHover" @mouseleave="imageOnBlur">
        <!--<el-input v-model="input" placeholder="placeholder"></el-input>-->
        <el-button type="text" class="check-btn" v-if="!inputShow"
                   @click="inputCheckText">
          <i class="el-icon-edit danger-text" v-if="!checkText"></i>
          <span class="check-text" v-else>{{checkText}}</span>
        </el-button>
        <el-input v-else  v-model="checkText" ref="input" class="check-btn check-text-input"  placeholder="请输入修改意见"
                  @blur="handleBlur" @keyup.enter.native="handleBlur"></el-input>
      </div>
      <img
        v-lazy="image.dish_img_url"
        class="image"
      />
    </div>
  </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';

export default {
  name: 'imageItem',
  components: {

  },
  props: {
    optionShow: true,
    image: {
      type: Object,
      default () {
        return {};
      }
    },
    selfCheck: false,
    dish_img_uuid: '',
    modelList: {
      type: Array,
      default () {
        return [];
      }
    }

  },
  data () {
    return {
      iconShow: false,
      inputShow: false,
      checkText: ''
    };
  },
  mounted () {
    this.checkText = this.getCheckList();
  },
  methods: {
    ...mapMutations([
      'addCheckTextObj'
    ]),
    getCheckList () {
      console.log(this.checkTextObjList);
      let obj = this.$_.find(this.checkTextObjList, (o) => {
        return o.dish_img_uuid === this.image.dish_img_uuid;
      });
      if (obj) {
        return obj.check_text;
      }
    },
    handleBlur () {
      this.inputShow = false;
      // 提交checktext
      // if (this.checkText) {
      //
      // }
      this.addCheckTextObj({
        dish_img_uuid: this.image.dish_img_uuid,
        check_text: this.checkText
      });
    },
    inputCheckText () {
      this.inputShow = true;
      this.$nextTick(() => {
        console.log(this.$refs);
        this.$refs['input'].focus();
      });
    },
    handleDelete () {
      this.$confirm('是否删除此图片?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        this.$emit('delete', {dish_img_uuid: this.dish_img_uuid});
        this.$message({
          type: 'success',
          message: '删除成功'
        });
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '您已取消删除'
        });
      });
    },
    imageOnHover () {
      this.iconShow = true;
    },
    imageOnBlur () {
      this.iconShow = false;
    },
    handleUnmark () {
      this.$emit('unMark', {dish_img_uuid: this.dish_img_uuid, class_id: this.image.class_id});
    },
    handleMark () {
      setTimeout(() => {
        this.$emit('mark', this.dish_img_uuid);
      }, 200);
    }
  },
  computed: {
    ...mapGetters([
      'checkTextObjList'
    ]),
    selfChecked () {
      return this.$route.query.selfCheck;
    },
    deleteShow () {
      return this.$router.currentRoute.name === 'checkProcess' && this.selfCheck === true;
    }
  }
};
</script>
<style lang="scss" scoped>
  .container {
    margin-bottom: 10px;
    .image-wrapper {
      position: relative;
      display: inline-block;
      width: 150px;
      height: 150px;
      text-align: center;
      background-color: #ccc;
      .btn-wrapper {
        position: absolute;
        right: 0px;
        width: 30px;
        z-index: 100;
        text-align: center;
        .btn {
          padding: 0;
          margin: 5px 0 ;
        }
      }
      .icon {
        position: absolute;
        top: 0;
        right: 0;
        color: #13ce66;
        font-size: 30px;
        background-color: #fff;
        border-radius: 50%;
      }
      .mask-wrapper {
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        cursor: pointer;
        text-align: center;
        .check-btn {
          padding: 0;
          line-height: 150px;
          font-size: 26px;
          font-weight: bold;
          color: #fff;
          .check-text {
            display: inline-block;
            width: 120px;
            height: 20px;
            line-height: 20px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            padding: 5px;
            background: rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            font-size: 16px;
            color: #ddd;
          }
          &.el-icon-circle-plus-outline {
            color: #00ff00;
          }
          &.el-icon-delete {
            color: #ff0000;
          }
        }
        .check-text-input {
          font-size: 16px;
          background: rgba(0, 0, 0, 0.5);
        }
        &:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }
      }
      .image {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
</style>
